import { defineComponent as _defineComponent } from 'vue'
import Breadcrumb from '@/components/ui/breadcrumb/Breadcrumb.vue'
import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Map.layout',
  setup(__props) {

const crumbs = ref([
	{ name: 'Cadastro Zona de Exclusão', step: 0 },
	{ name: 'Definiçao da área', step: 1 },
])

const step = ref(1)

return { __sfc: true,crumbs, step, Breadcrumb }
}

})